<template>
	<div class="skip-icon">
		<img class="icon1" :data-src="g+imgList[0]" />
		<img class="icon2" :data-src="g+imgList[1]" />
	</div>
</template>

<script>
	export default{
		props:{
			type:{
				type:String,
				default:'1'
			}
		},
		name: "",
		components: {},
		data(){
			 let g=process.env.VUE_APP_BASE_URL+'sustainability'
			return{
				g:g,
				imgList:[],
			}
		},
		created(){
			if(this.type=='1'||!this.type){
				this.imgList=['/150.png','/151.png']
			}else{
				this.imgList=['/146.png','/439.png']
			}
		}
	}
</script>

<style lang="scss" scoped >
	.skip-icon{
		position: relative;
		width: 98px;
		height: 98px;
		
		.icon1{height: 47.69px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(13.676px, 9.541px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 47.29px;}
		.icon2{height: 31.00px;
    left: 0px;
    position: absolute;
    top: 0px;
    transform: translate(21.234px, 50.330px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
    transform-origin: 0% 0%;
    width: 58.65px;}
	}
	
</style>